module.exports = __webpack_public_path__ + "img/5647c1d.png";